import { RouterProvider } from 'react-router-dom';

import { Providers } from './providers';
import { router } from './routes';
import { useAuthBootstrap } from './useAuthBootstrap';

/**
 * 應用程式根元件
 * -----------------------------------------------------------------------------
 * 所有路由、Provider、全域配置皆由此發散。掛載後立刻：
 *
 * 1. ``useAuthBootstrap`` 一次性向後端探查 session 是否仍有效。
 * 2. 探查期間 ``RequireAuth`` 會顯示 loading；完成後依結果決定是否要導去 ``/login``。
 *
 * @example
 *   createRoot(rootElement).render(<App />);
 */
export function App() {
  useAuthBootstrap();
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
